module.exports = __webpack_public_path__ + "static/media/wagz-logo.6e0fbf79.png";